import React, { Component } from 'react'
import { connect } from 'react-redux';
import Service from '../../services';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import ClassetMultiSelect from '../../classetComponents/classetMultiSelect';
import { BoardsIconInActive, GradesIcon } from '../svgIcons';
import { Toast } from 'primereact/toast';
import LoadingComponent from '../loadingComponent';
import { getBoardsData, getBranchesLatest } from '../../store/actions';
import { baseUrlAdmin } from '../../store/apiConstants';
import { userAssignedBoards } from '../../store/selectors/userAssignedBoards';
import { cloneDeep } from 'lodash';

let selectedBoardClasses;
let filteredSections;
class BranchToClassDDRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            boardId: [],
            classId: [],
            groupId: null,
            branchId: [],
            sectionId: null,
            boards: [],
            classes: [],
            curriculumInfo: {},
            selectedrowData: this.props?.rowData
        };
        this.service = new Service()
    }

    componentDidMount() {
        this.getData();
        // Initialize with saved values if available
        if (this.props.initialValues) {
            const { branchId, boardId, classId } = this.props.initialValues;
            this.setState({
                branchId,
                boardId,
                classId: classId || []
            }, () => {
                if (branchId) this.onChangeBranch(branchId);
                if (boardId) this.onChangeBoard(boardId);
                if (classId) this.onChangeClass(classId);
            });
        }
    }

    componentDidUpdate() {


    }

    getData = () => {
/*         this.props.getBranchesLatest();
        this.props.getBoardsData(true) */
    }

    // Helper method to check if user is a teacher
    isTeacher = () => {
        // Check user type from localStorage
        const userType = localStorage.getItem('type');
        
        // Only if type is 'teacher', check for assignedSubjects
        if (userType === 'teacher') {
            return this.props.userInfo?.assignedSubjects && this.props.userInfo.assignedSubjects.length > 0;
        }
        
        // For all other types (admin, staff, etc.), return false (they get all sections)
        return false;
    }

    // Helper method to remove duplicates based on unique ID
    removeDuplicates = (array, idKey) => {
        if (!array || array.length === 0) return [];
        
        const seen = new Set();
        return array.filter(item => {
            const id = item[idKey];
            if (seen.has(id)) {
                return false;
            }
            seen.add(id);
            return true;
        });
    }

    // Filter branches based on user's assigned branches
    getFilteredBranches = () => {
        const { userInfo, branchData } = this.props;

        // If user is admin, return all branches
        if (userInfo?.isAdmin === true) {
            return this.removeDuplicates(branchData || [], 'key');
        }

        // For non-admin users, filter by assigned branches
        if (!userInfo.branchs || userInfo.branchs.length === 0) {
            return this.removeDuplicates(branchData || [], 'key');
        }

        const filtered = branchData.filter(branch =>
            userInfo.branchs.includes(branch.key)
        );
        
        return this.removeDuplicates(filtered, 'key');
    }

    // Filter boards based on user's assigned branches and boards
    getFilteredBoards = (selectedBranchIds) => {
        const { userInfo, boards } = this.props;

        let filteredBoards = cloneDeep(boards || []);

        // If user is admin, return all boards (filtered only by selected branches if any)
        if (userInfo?.isAdmin === true) {
            // Filter by selected branches only
            if (selectedBranchIds && selectedBranchIds.length > 0) {
                filteredBoards = filteredBoards.filter(board =>
                    board.assignedBranches.some(branchId => selectedBranchIds.includes(branchId))
                );
            }
        } else {
            // For non-admin users, filter by selected branches
            if (selectedBranchIds && selectedBranchIds.length > 0) {
                filteredBoards = filteredBoards.filter(board =>
                    board.assignedBranches.some(branchId => selectedBranchIds.includes(branchId))
                );
            }

            // For teachers, additionally filter by assigned boards
            if (this.isTeacher() && userInfo?.boardId && userInfo?.boardId.length > 0) {
                filteredBoards = filteredBoards.filter(board =>
                    userInfo?.boardId.includes(board.boardId)
                );
            }
            // For non-admin, non-teacher users, filter by assigned boards if available
            else if (!this.isTeacher() && userInfo?.boardId && userInfo?.boardId.length > 0) {
                filteredBoards = filteredBoards.filter(board =>
                    userInfo?.boardId.includes(board.boardId)
                );
            }
        }

        // Remove duplicate boards by boardId
        filteredBoards = this.removeDuplicates(filteredBoards, 'boardId');

        return filteredBoards;
    }

    onChangeBranch = (branchIds) => {
        this.setState({
            boards: [], classes: [], sections: [],
        });
        let selectedbranchNames = this.props.branchData
            ?.filter((branchd) => branchIds.includes(branchd.key))
            ?.map(branch => branch.name);
        
        // Use filtered boards based on selected branches and user role
        let filteredBoards = this.getFilteredBoards(branchIds);

        this.setState({
            branchId: branchIds,
            selectedbranchName: selectedbranchNames.join(', '),
            boards: filteredBoards,
            classes: [],
            boardId: [],
            selectedBoardName: '',
            classId: [],
            selectedClass: {},
            branches: [],
            selectedClassName: '',
            sections: [],
            sectionId: '',
            selectedsectionName: '',
        }, );
    };

    onChangeBoard = (boardIds) => {
        this.setState({
            classes: [],
            sections: [],
        });

        const selectedBoards = boardIds.map(boardId => 
            this.state.boards?.find((board) => board.boardId === boardId) ||
            this.props.boards?.find((board) => board.boardId === boardId)
        ).filter(Boolean);

        if (!selectedBoards.length) {
            this.setState({
                classes: [],
                boardId: [],
                selectedBoardName: '',
                classId: [],
                selectedClass: {},
                branches: [],
                selectedClassName: '',
                sections: [],
                sectionId: '',
                selectedsectionName: '',
            },);
            return;
        }

        const allClasses = selectedBoards.flatMap(board => board.classes || []);

        // Remove duplicate classes by classId
        const uniqueClasses = this.removeDuplicates(allClasses, 'classId');

        this.setState({
            classes: uniqueClasses,
            boardId: boardIds,
            selectedBoardName: selectedBoards.map(board => board.boardName).join(', '),
            classId: [],
            selectedClass: {},
            branches: [],
            selectedClassName: '',
            sections: [],
            sectionId: '',
            selectedsectionName: '',
        }, );
    };

    onChangeClass = (classId) => {
        // Add null check for classes
        if (!Array.isArray(classId)) {
            classId = [];
        }

        let selectedClass = this.state.classes ?
            this.state.classes.filter((classd) => classId.includes(classd.classId)) :
            [];

        let filteredSections = selectedClass ?
            selectedClass.flatMap((classd) =>
                (classd.sections || []).filter((sec) => sec.branchId == this.state.branchId)
            ) : [];

        this.setState({
            classId: classId,
            selectedClass: selectedClass,
            selectedClassName: selectedClass.map((classd) => classd.className || '').join(', '),
            sections: filteredSections,
            sectionId: '',
            selectedsectionName: '',
        }, () => this.setDropdownsData());
    };

    setDropdownsData = () => {
        let {
            boardId,
            classId,
            branchId,
            sectionId,
            selectedBoardName,
            selectedClassName, 
            selectedbranchName, 
            selectedsectionName
        } = this.state

        let returnData = {
            boardId, 
            classId, 
            branchId, 
            sectionId, 
            selectedBoardName,
            selectedClassName, 
            selectedbranchName, 
            selectedsectionName
        }
        
        // Only call setValues if it exists as a function
        if (typeof this.props.setValues === 'function') {
            this.props.setValues(returnData)
        }
    }

    render() {
        // Get filtered branches for the dropdown options
        const filteredBranchData = this.getFilteredBranches();

        return (
            <div>
                <div >
                    <div className='grid mx-1'>
                        <div className="col-4 my-2">
                            <ClassetMultiSelect required={true} label={'Branch'} placeholder={'Select Branch'} options={filteredBranchData}
                                value={this.state.branchId}
                                disabled={this.props?.disable >= 1}
                                onChange={(e) => this.onChangeBranch(e.value)} 
                                optionLabel="name"
                                optionValue="key"
                                multiple={true} />
                        </div>
                        <div className="col-4 my-2">
                            <ClassetMultiSelect required={true} label={'Board'} placeholder={'Select Board'} 
                                options={this.state?.boards} 
                                value={this.state.boardId} 
                                onChange={(e) => this.onChangeBoard(e.value)} 
                                optionLabel="boardName"
                                optionValue="boardId"
                                disabled={this.props?.disable >= 2}
                                multiple={true} />
                        </div>
                        <div className="col-4 my-2">
                            <div className="p-field">
                                <ClassetMultiSelect
                                    label="Class"
                                    value={this.state.classId}
                                    options={this.state.classes.map((classd) => ({
                                        label: classd.className,
                                        value: classd.classId
                                    }))}
                                    onChange={(e) => this.onChangeClass(e.value)}
                                    disabled={!this.state.boardId}
                                    placeholder="Select Classes"
                                    className="w-100"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
                {this.state.isLoading && <>
                    <LoadingComponent />
                </>}
            </div>
        )
    }
}

const mapStatesToProps = (state) => ({
    // boards: state.boardsData.boards,
    boards: userAssignedBoards(state, 'activeBoards'),
    branchData: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.data.filter((each => {
        if (each.level == 1) {
            return { ...each }
        }
    })) || [],
    permissionIds: state.currentUserPerms && state.currentUserPerms.permissionIds && state.currentUserPerms.permissionIds,
    userInfo: state.currentUserPerms && state.currentUserPerms.userInfo ? state.currentUserPerms.userInfo : {},
});
export default connect(mapStatesToProps, { getBoardsData, getBranchesLatest })(BranchToClassDDRow);